import React from 'react';
import Icon from '../../../components/AppIcon';

const ValidationTable = ({ rows, columns }) => {
  if (!rows?.length) return null;

  const errorRows = rows?.filter(r => r?._errors?.length > 0);
  const validRows = rows?.filter(r => !r?._errors?.length);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4 text-sm">
        <span className="flex items-center gap-1.5 text-success font-medium">
          <Icon name="CheckCircle" size={15} />
          {validRows?.length} valid
        </span>
        {errorRows?.length > 0 && (
          <span className="flex items-center gap-1.5 text-error font-medium">
            <Icon name="XCircle" size={15} />
            {errorRows?.length} with errors
          </span>
        )}
      </div>

      {errorRows?.length > 0 && (
        <div className="border border-error/30 rounded-lg overflow-hidden">
          <div className="bg-error/5 px-4 py-2 border-b border-error/20">
            <p className="text-xs font-semibold text-error uppercase tracking-wide">Rows with errors (will be skipped)</p>
          </div>
          <div className="divide-y divide-border max-h-48 overflow-y-auto">
            {errorRows?.map((row, i) => (
              <div key={i} className="px-4 py-2.5 flex items-start gap-3">
                <span className="text-xs text-text-secondary mt-0.5 shrink-0">Row {row?._rowIndex}</span>
                <div className="flex flex-wrap gap-1.5">
                  {row?._errors?.map((err, j) => (
                    <span key={j} className="inline-flex items-center gap-1 px-2 py-0.5 bg-error/10 text-error text-xs rounded-full">
                      <Icon name="AlertCircle" size={11} />
                      {err}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ValidationTable;
